/* Referência única para redesenhar a tela.

   O quadro e a camada de banco precisam pedir um redesenho, mas quem sabe
   desenhar é o main.js, que por sua vez importa os dois. Importar de volta
   criaria dependência circular. Então o main registra a função aqui, e todo
   mundo chama desenhar() sem precisar conhecer o main. */
let atual = () => {};

export function definirDesenho(fn){ atual = fn; }
export function desenhar(){ atual(); }
